

![demo_frontpage](/content/assets/images/demo_frontpage.png)
首页展示实验实例.

![experiment_page](/content/assets/images/experiment_page.png)
实验实例页面展示播放队列列表，对于每个播放队列卡片，自上而下依次是：
- 队列id，一般是歌单编号_排序方法，_original_order 代表歌单的原始顺序。
- 歌单名称，用于在酷狗音乐客户端中搜索。
- 本地测试中根据歌曲特征计算的成功、BPM差幅过大、失败的数量和占比，以及歌曲总量。

![mix_pageClientTest](/content/assets/images/mixPlayerPageClientTest.png)
播放队列和混音情况界面中，对于对比客户端效果，有几个地方需要留意：
- ① 导航界面右侧的图标指示了根据歌曲特征计算的混音生效情况，如果图标是黄色[BPM]或者红色[不通过]，
那么这两首歌在客户端应该降级为渐进/无缝过渡，此时不可以参考demo页的强行混音效果。
- ② 导航界面左侧的序号如果标红，表示本地测试中拉取到的资源存在问题，没有生成效果。
- ③ 指示了过渡的前一首歌的开始过渡时间，可以用这个时间定位客户端的进度条快速预览过渡效果。
- ④ 播放器波形重合的地方为过渡片段，通过对比demo和线上的听感，可以判断过渡效果是否正确。